import { useState, useEffect, useRef } from 'react';
import { products } from './products';

import axios from 'axios'
import { isMobile, isAndroid, isIOS } from 'react-device-detect';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'

import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import { WrenchAdjustable, BoxSeam, Headset, Basket, Book, People, EnvelopeFill, Whatsapp, TelephoneFill, Facebook } from 'react-bootstrap-icons';

import logo_start from './img/logo_w.png'
import logo from './img/logo.png'
import us from './img/us.jpg'
import alpha from './img/brands/alpha.jpg'
import blue from './img/brands/blue.jpg'
import hid from './img/brands/hid.jpg'
import kb from './img/brands/kb.jpg'
import newland from './img/brands/newland.jpg'
import sewooo from './img/brands/sewooo.jpg'
import tsc from './img/brands/tsc.jpg'
import barcode from './img/brands/barcode.jpg'

const API_PATH = '';
const SITE_KEY = '';

function App() {
  const images = { logo, logo_start }
  const [ image, setImage ] = useState(images['logo_start'])

  const refHome = useRef(null);
  const refUs = useRef(null);
  const refProducts = useRef(null);
  const refServices = useRef(null);
  const refContact = useRef(null);

  const [showMessage, setShowMessage] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [title, setTitle] = useState('');
  const [message, setMessage] = useState('');
  const [ activeForm, setActiveForm ] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);

  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [comments, setComments] = useState("");

  const [ faceLink, setFaceLink ] = useState('https://www.facebook.com/provservtec.com.mx');

  const [ goingUp, setGoingUp ] = useState(false);
  const prevScrollY = useRef(0);

  useEffect(() => {
    
    if ( isMobile ) {
      if( isAndroid )
        setFaceLink('fb://page/111933257823824')
      else if( isIOS )
        setFaceLink('fb://profile/111933257823824')
    }

    const loadScriptByURL = (id, url, callback) => {
      const isScriptExist = document.getElementById(id);
 
      if (!isScriptExist) {
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = url;
        script.id = id;
        script.onload = function () {
          if (callback) callback();
        };
        document.body.appendChild(script);
      }
 
      if (isScriptExist && callback) callback();
    }
 
    // load the script by passing the URL
    loadScriptByURL("recaptcha-key", `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`, function () {
      console.log("Script loaded!");
    });
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (prevScrollY.current < currentScrollY && goingUp) {
        setGoingUp(false);
      }
      if (prevScrollY.current > currentScrollY && !goingUp) {
        setGoingUp(true);
      }

      prevScrollY.current = currentScrollY;

      if(currentScrollY > 10) {
        document.getElementById("rensa-navbar").className = "nav-bar-custom navbar navbar-expand-lg fixed-top";
        document.getElementById("brand_image").className = "d-inline-block align-top brand-image";
        setImage(images['logo'])

        var navs = document.getElementsByClassName('nav-link-custom');
        for(var i = 0; i < navs.length; i++) {
          navs[i].style.color = '#000';
        }

        var icons = document.getElementsByClassName('nav-icons');
        for(var i = 0; i < icons.length; i++) {
          icons[i].style.color = '#000';
        }
      } else {
        document.getElementById("rensa-navbar").className = "nav-bar-custom-start navbar navbar-expand-lg navbar-dark fixed-top";
        document.getElementById("brand_image").className = "d-inline-block align-top brand-image-start";
        setImage(images['logo_start'])

        var navs = document.getElementsByClassName('nav-link-custom');
        for(var i = 0; i < navs.length; i++) {
          navs[i].style.color = isMobile ? '#000' : '#fff';
        }

        var icons = document.getElementsByClassName('nav-icons');
        for(var i = 0; i < icons.length; i++) {
          icons[i].style.color = isMobile ? '#000' : '#fff';
        }
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => window.removeEventListener("scroll", handleScroll);
  }, [goingUp]);

  const handleNavClick = (eventKey) => {
    const yOffset = -100; 
    const element = eval(eventKey).current;
    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

    window.scrollTo({top: y, behavior: 'smooth'});
  }

  const handleOnClick = (e) => {
    e.preventDefault();
    setLoading(true);
    window.grecaptcha.ready(() => {
      window.grecaptcha.execute(SITE_KEY, { action: 'submit' }).then(token => {
        handleOnSubmit(token);
      });
    });
  }

  const handleOnSubmit = (token) => {
    var form = document.getElementById('contactForm');
    var data = new FormData(form);
    data.append('recaptcha_response', token);

    axios.post(API_PATH, data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
    }).then(function(response) {

      if(response.data == "FAIL" || response.data == "ERROR") {
        setLoading(false)
        if(isMobile) setActiveForm(false)
        setTitle("Error")
        setMessage("Ocurrió un error al intentar enviar tu mensaje, por favor intenta mas tarde.");
        setShowMessage(true)
      } else {
        setLoading(false)
        if(isMobile) setActiveForm(false)
        setTitle("Mensaje enviado")
        setMessage("Tu mensaje ha sido enviado. En breve nos comunicaremos contigo. Gracias.");
        setShowMessage(true)

        setName("");
        setPhone("");
        setEmail("");
        setComments("");
        setShow(false);
      }

    }).catch(function(err) {
      setLoading(false)
      setTitle("Error")
      setMessage("Ocurrió un error al intentar enviar tu mensaje, por favor intenta mas tarde.");
      setShowMessage(true)
    });
  }

  const handleCloseMessage = () => setShowMessage(false);

  return (
    <div className="App">
      <Modal show={showMessage} onHide={handleCloseMessage}>
        <Modal.Header style={{ background: "#fff" }} closeButton>
          <Modal.Title style={{ color: "#000" }}>{ title }</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ color: "#000", background: "#fff" }}>{ message }</Modal.Body>
        <Modal.Footer style={{ color: "#000", background: "#fff" }}>
          <Button variant="secondary" onClick={handleCloseMessage}>
            Aceptar
          </Button>
        </Modal.Footer>
      </Modal>

      <Navbar id="rensa-navbar" collapseOnSelect expand="lg" variant="dark" className="nav-bar-custom-start" fixed="top">
        <Container>
          <Navbar.Brand href="#home">
            <img alt="" id="brand_image" src={ image } height="auto" width="180px" className="d-inline-block align-top brand-image-start" onClick={() => handleNavClick("refHome")}/>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="me-auto">
            </Nav>
            <Nav onSelect={handleNavClick}>
              <Nav.Link eventKey="refUs">
                <div className="nav-link-custom">Quiénes somos</div>
              </Nav.Link>
              <Nav.Link eventKey="refProducts">
                <div className="nav-link-custom">Productos</div>
              </Nav.Link>
              <Nav.Link eventKey="refServices">
                <div className="nav-link-custom">Servicios</div>
              </Nav.Link>
              <Nav.Link eventKey="refContact">
                <div className="nav-link-custom">Contacto</div>
              </Nav.Link>

              <Nav.Link className="nav-link-custom nav-link-icons" onClick={ () =>  window.open(faceLink) }>
                <Facebook className="nav-icons"/>
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <div className="banner-bg" ref={ refHome }>
        <Container>
          <Row>
            <Col md={ 5 }>
            </Col>
            <Col md={ 7 }>
              <div className="banner-title">
                <div><span className='banner-title-700'>Innovación tecnológica</span> para tu vida diaria, aplicable a tu <span className='banner-title-700'>negocio o industria</span></div>
                <div align={ isMobile ? "center" : "right"} style={{ paddingTop: '20px' }}>
                  <Button variant="outline-primary" onClick={() => handleNavClick("refContact")}>
                    CONTÁCTANOS
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </Container>

        <div className="brands-container" align="center">
          <Container className="brands">
            <Row>
              <Col xs={ 4 } md={ 3 }>
                <img src={ alpha } className="brands-img"/>
              </Col>
              <Col xs={ 4 } md={ 3 }>
                <img src={ blue } className="brands-img"/>
              </Col>
              <Col xs={ 4 } md={ 3 }>
                <img src={ hid } className="brands-img"/>
              </Col>
              <Col xs={ 4 } md={ 3 }>
                <img src={ kb } className="brands-img"/>
              </Col>
              <Col xs={ 4 } md={ 3 }>
                <img src={ newland } className="brands-img"/>
              </Col>
              <Col xs={ 4 } md={ 3 }>
                <img src={ sewooo } className="brands-img"/>
              </Col>
              <Col xs={ 4 } md={ 3 }>
                <img src={ tsc } className="brands-img"/>
              </Col>
              <Col xs={ 4 } md={ 3 }>
                <img src={ barcode } className="brands-img"/>
              </Col>
            </Row>
          </Container>
        </div>
      </div>

      <div className="section-a" ref={ refUs }>
        <Container>
          <div className="secction-titles align-center">
            ¿QUIÉNES SOMOS?
          </div>
          <br/>
          <br/>
          <Row className="align-items-center">
            <Col md={ 6 } xs={ 12 }>
              <img src={ us } className="us-img"/>
            </Col>
            <Col md={ 6 } xs={ 12 }>
              <div className="grl-text p-30">
                Te ayudamos a llevar tu negocio al siguiente nivel, con equipo profesional y de diversas modalidades para impresión y etiquetado, consumibles e insumos, codificación y marcaje y trazabilidad y movilidad ofreciéndote las principales marcas del mercado mundial. 
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <div className="section-b" ref={ refProducts }>
        <Container>
          <Row>
            <Col md={ 8 }>
              <div className={ isMobile ? "secction-titles align-center" : "secction-titles align-left" }>
                NUESTROS PRODUCTOS
              </div>
              <br/>
              <div className="grl-text">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
              </div>
            </Col>
            { products.map( item => (
              <Col md={ 4 } className="p-item-padding" key={ item.name }>
                <div className='p-card'>
                  <div align="center"><img className="img-card" src={ item.image }/></div>
                  <br/>
                  <div className='t-card'> { item.name } </div>
                  <div className='b-card'> { item.brand } </div>
                </div>
              </Col>
            ))}
            
          </Row>
        </Container>
      </div>

      <div className="section-c" ref={ refServices }>
        <Container>
          <div className="secction-titles align-center c-white">
            NUESTROS SERVICIOS
          </div>
          <br/>
          <div className="grl-text align-center c-white">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </div>
          <br/><br/>
          <Row>
            <Col md={ 6 } className="p-item-padding">
              <fieldset className="scheduler-border">
                  <legend className="scheduler-border">
                    <WrenchAdjustable />&nbsp;&nbsp;
                    <span className="grl-title align-left c-white">
                      INSTALACIÓN
                    </span>
                  </legend>
                  <div className="control-group">
                    <br/>
                    <div className="grl-text align-left c-white">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                    </div>
                  </div>
              </fieldset>
            </Col>
            <Col md={ 6 } className="p-item-padding">
              <fieldset className="scheduler-border">
                  <legend className="scheduler-border">
                    <Book />&nbsp;&nbsp;
                    <span className="grl-title align-left c-white">
                      CAPACITACIÓN
                    </span>
                  </legend>
                  <div className="control-group">
                    <br/>
                    <div className="grl-text align-left c-white">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                    </div>
                  </div>
              </fieldset>
            </Col>

            <Col md={ 6 } className="p-item-padding">
              <fieldset className="scheduler-border">
                  <legend className="scheduler-border">
                    <People />&nbsp;&nbsp;
                    <span className="grl-title align-left c-white">
                      ASESORAMIENTO
                    </span>
                  </legend>
                  <div className="control-group">
                    <br/>
                    <div className="grl-text align-left c-white">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                    </div>
                  </div>
              </fieldset>
            </Col>

            <Col md={ 6 } className="p-item-padding">
              <fieldset className="scheduler-border">
                  <legend className="scheduler-border">
                    <Headset />&nbsp;&nbsp;
                    <span className="grl-title align-left c-white">
                      SOPORTE TÉCNICO
                    </span>
                  </legend>
                  <div className="control-group">
                    <br/>
                    <div className="grl-text align-left c-white">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                    </div>
                  </div>
              </fieldset>
            </Col>

            <Col md={ 6 } className="p-item-padding">
              <fieldset className="scheduler-border">
                  <legend className="scheduler-border">
                    <BoxSeam />&nbsp;&nbsp;
                    <span className="grl-title align-left c-white">
                      REFACCIONES
                    </span>
                  </legend>
                  <div className="control-group">
                    <br/>
                    <div className="grl-text align-left c-white">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                    </div>
                  </div>
              </fieldset>
            </Col>

            <Col md={ 6 } className="p-item-padding">
              <fieldset className="scheduler-border">
                  <legend className="scheduler-border">
                    <Basket />&nbsp;&nbsp;
                    <span className="grl-title align-left c-white">
                      CONSUMIBLES E INSUMOS
                    </span>
                  </legend>
                  <div className="control-group">
                    <br/>
                    <div className="grl-text align-left c-white">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                    </div>
                  </div>
              </fieldset>
            </Col>
            
          </Row>
        </Container>
      </div>

      <div className="section-d" ref={ refContact }>
        <Container>
          <Row>
            <Col md={ 6 }>
              <div className={ isMobile ? "secction-titles align-center c-white" : "secction-titles align-left c-white" }>
                CONTÁCTANOS
              </div>
              <br/>
              <div className="grl-text align-left c-white">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
              </div>
              <br/>
              <div className='mb-3' style={{ cursor: 'pointer' }}  onClick={ () =>  window.open("mailto:info@provservtec.com.mx") }>
                <EnvelopeFill className="contact-info align-left c-white"/>&nbsp;&nbsp;&nbsp;&nbsp;
                <span className="contact-info align-left c-white">
                  info@provservtec.com.mx
                </span>
              </div>
              <div className='mb-3' style={{ cursor: 'pointer' }} onClick={ () =>  window.open("https://wa.me/5215555555555") }>
                <Whatsapp className="contact-info align-left c-white"/>&nbsp;&nbsp;&nbsp;&nbsp;
                <span className="contact-info align-left c-white">
                  55 5555 5555
                </span>
              </div>
              <div className='mb-3'>
                <TelephoneFill className="contact-info align-left c-white"/>&nbsp;&nbsp;&nbsp;&nbsp;
                <span className="contact-info align-left c-white">
                  <a href="tel:5570958710">55 7095 8710</a> y <a href="tel:5570958713">55 7095 8713</a>
                </span>
              </div>
            </Col>
            <Col md={ 6 } className="form-container">
              <div className="secction-titles align-left c-white">
                &nbsp;
              </div>
              <Form id="contactForm" onSubmit={handleOnClick}>
                <Form.Group className='mb-3'>
                  <Form.Label className="label-custom">Nombre completo</Form.Label>
                  <Form.Control required name="name" value={name} onChange={ (e) => setName(e.target.value) } />
                </Form.Group>

                <Form.Group className='mb-3'>
                  <Form.Label className="label-custom">Correo Electrónico</Form.Label>
                  <Form.Control required type="email" value={email} name="email" onChange={ (e) => setEmail(e.target.value) } />
                </Form.Group>

                <Form.Group className='mb-3'>
                  <Form.Label className="label-custom">Teléfono</Form.Label>
                  <Form.Control required type="number" value={phone} name="phone" onChange={ (e) => setPhone(e.target.value) } />
                </Form.Group>

                <Form.Group className='mb-3'>
                  <Form.Label className="label-custom">Déjanos un mesaje (opcional)</Form.Label>
                  <Form.Control required name="comments" as="textarea" value={comments} rows="2" onChange={ (e) => setComments(e.target.value) } />
                </Form.Group>

                <div align="right">
                  <Button variant="outline-primary" type="submit">
                    ENVIAR
                  </Button>
                </div>
              </Form>
            </Col>
          </Row>
        </Container>

      </div>
      <div className='footer'>
          <Container>
            <Row>
              <Col md={ 2 }>
              </Col>
              <Col md={ 8 }>
                <img className="footer-logo" src={ logo_start } />
                <br/>
                <br/>
                <div>
                  <div className='footer-title'>Siguenos en redes sociales</div>
                  <br/>
                  <Facebook className="footer-icons" onClick={ () =>  window.open(faceLink) } />&nbsp;&nbsp;
                </div>
                <br/>
                <div className='footer-title' onClick={ () => setShowPrivacy(true) }>
                  Aviso de privacidad
                </div>
              </Col>
              <Col md={ 2 }>
              </Col>
            </Row>
          </Container>
      </div>

      <Modal show={showPrivacy} onHide={ () => setShowPrivacy(false) } size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Header closeButton className="modal-service-header"></Modal.Header>
        <Modal.Body className="modal-service-body">
          <br/>
          <div className="modal-service-body-text">
            <div className="policy-title modal-title-style">AVISO DE PRIVACIDAD PARA CLIENTES</div>
            <br/>
            <div className="policy-desc">
              De conformidad con lo establecido en el Artículo 17, fracción II de la Ley Federal de Protección de Datos Personales en posesión de los particulares le informamos que DPA DIGITAL MARKETING S DE RL DE CV (el "Responsable"), con domicilio en Av. Cerezos #66 San Juan Ixtacala, Atizapán de
              Zaragoza, C.P. 52928 Estado de México y portal de internet https://digital-eureka.com/ Tratará los datos personales que recabe de usted en su carácter de cliente y/o usuario, mismos que serán utilizados para identificarlo con las siguientes finalidades:
              Enviarle promociones e información generada por el "Responsable".<br/>
              Para fines estadísticos, publicitarios, promocionales, mercadológicos o de prospección comercial.<br/>
              Información sobre los servicios que el "Responsable" le proporciona.<br/>
              Enviarle facturas o alguna otra información derivada de la relación comercial.<br/>
              Atender y dar seguimiento a quejas.<br/>
              Llevar un récord de contrataciones por parte de su compañía de alguno de los servicios que ofrece el "Responsable".<br/>
              Por lo tanto y para alcanzar las finalidades antes expuestas, se tratarán los siguientes datos personales: nombre, teléfono y correo electrónico.
              <br/><br/>
              <b>Sistemas utilizamos para la captura de estos datos</b>
              <br/>
              1) Formularios de suscripción a contenidos: dentro de la web https://digital-eureka.com/ existen varios formularios para activar la suscripción  con la finalidad de enviar campañas de marketing por correo electrónico, gestión de suscripciones y envío de boletines o noticias.
              2) Formulario de comentarios: La web incluye un formulario cuya finalidad es comentar los artículos y dar su opinión respetando la libertad de expresión. El usuario podrá publicar comentarios en los post que se publiquen. Los datos personales introducidos en el formulario para insertar estos comentarios serán utilizados exclusivamente para moderarlos y publicarlos,
              recabando igualmente estos datos que se almacenarán en los servidores de Godaddy.
              3) Formulario de contacto: Existe un formulario de contacto cuya finalidad es la respuesta de consultas, sugerencias o contacto profesional. En este caso se utilizará la dirección de correo electrónico para responder a las mismas y enviar la información que el usuario requiera a través de la web, estos datos se almacenarán en los servidores de Godaddy.
              4) Cookies: Cuando el usuario se registra o navega en esta web, se almacenan “cookies”, El usuario puede consultar en cualquier momento la política de cookies para ampliar información sobre el uso de cookies y como desactivarlas.
              6) Los usuarios podrán darse de baja en cualquier momento de los servicios prestados por https://digital-eureka.com/ desde la misma Newsletter a través de un formulario de cancelación.
              7) Sistemas de rastreo utilizadas en este sitio: Google (Analytics), en https://digital-eureka.com/ también se estudian las preferencias de sus usuarios, sus características demográficas, sus patrones de tráfico, y otra información en conjunto para comprender mejor quiénes constituyen su audiencia y qué es lo que esta necesita.
              <br/><br/>
              El rastreo de las preferencias de nuestros usuarios también nos ayuda a mostrarle los avisos publicitarios más relevantes.
              <br/><br/>
              Asimismo, informamos que para la captación de suscriptores y clientes utilizamos Facebook Ads teniendo instalado el correspondiente Pixel de Facebook, por lo que al generar un anuncio, se puede segmentar el público por el lugar, datos demográficos, intereses, etc por lo que los datos obtenidos por esta plataforma, estarían sujetos a esta política de privacidad desde el momento en que el usuario deja sus datos para unirse al boletín de https://digital-eureka.com/
              <br/><br/>
              <b>¿Cómo puede acceder, rectificar o cancelar sus datos personales, u oponerse a su uso?</b>
              Usted tiene derecho a conocer qué datos personales tenemos de usted, para qué los utilizamos y las condiciones del
              uso que les damos (Acceso). Asimismo, es su derecho solicitar la corrección de su información personal en caso de
              que esté desactualizada, sea inexacta o incompleta (Rectificación); que la eliminemos de nuestros registros o bases
              de datos cuando considere que la misma no está siendo utilizada adecuadamente (Cancelación); así como oponerse
              al uso de sus datos personales para fines específicos (Oposición). Estos derechos se conocen como derechos
              ARCO.
              <br/><br/>
              Para el ejercicio de cualquiera de los derechos ARCO, usted deberá presentar la solicitud respectiva a través del
              siguiente medio:
              <br/>
              Enviando un correo electrónico a info@digital-eureka.com

              El responsable no vende ni venderá datos personales de los usuarios a otras empresas ni terceros.
              El responsable compartirá con terceros los datos que posee, solo para cumplir con los servicios contratados por algún usuario, enviar la newsletter, cumplir con exigencias legales o para la administración del sitio web. A este efecto, se proporcionarán los debidos acuerdos de confidencialidad entre las partes.
              Los enlaces a terceros que se puedan encontrar en el sitio web poseen políticas de privacidad ajenas a el responsable. El acceso a estos sitios deberá ser responsabilidad del usuario, siendo su responsabilidad conocerlas y su decisión aceptarlas o no.
              Los datos de contacto de la persona o departamento de datos personales, que está cargo de dar trámite a las solicitudes de derechos ARCO (GDPR), son los siguientes:
              a) Nombre de la persona o departamento de datos personales: Pablo Monroy Espejelb) Domicilio: Av Cerezos #66 San Juan Ixtacala, Atizapán de Zaragoza, Estado de México.
              c) Correo electrónico: info@digital-eureka.com
              <br/><br/>
              ¿Cómo puede limitar el uso o divulgación de su información personal?
              Con objeto de que usted pueda limitar el uso y divulgación de su información personal, le ofrecemos los siguientes medios: Enviar un correo a info@digital-eureka.com
              <br/><br/>
              El uso de tecnologías de rastreo en nuestro portal de internet. Le informamos que en nuestra página de internet utilizamos cookies, web beacons u otras tecnologías, a través de las cuales es posible monitorear su comportamiento como usuario de internet, asÌ como brindarle un mejor servicio y experiencia al navegar en nuestra página.
              Los datos personales que recabamos a través de estas tecnologías, los utilizaremos para los siguientes fines: Ofrecer servicios y productos relevantes para el usuario. Los datos personales que obtenemos de estas tecnologías de rastreo son los siguientes: Identificadores, nombre de usuario y contraseñas de una sesión, Idioma preferido por el usuario, región en la que se encuentra el usuario. Tipo de navegador del usuario, Tipo de sistema operativo del usuario, Fecha y hora del inicio y final de una sesión de un usuario, Páginas web visitadas por un usuario, Búsquedas realizadas por un usuario, Publicidad revisada por un usuario, Listas y hábitos de consumo en páginas de compras.
              <br/><br/>
              En relación con la gestión de tus datos asociados a los perfiles sociales de El Responsable, el ejercicio del derecho de acceso, dependerá de la funcionalidad de la red social y las posibilidades de acceso a la información de los perfiles de los usuarios. Con relación a los derechos de acceso y rectificación, le recomendamos que sólo podrá satisfacerse en relación a aquella información que se encuentre bajo el control de El Responsable Además podrá dejar de interactuar, seguir o recibir información de los perfiles sociales de El Responsable, eliminar los contenidos que dejen de interesarle o restringir con quien comparte sus conexiones, mediante los mecanismos estipulados en las diferentes redes sociales.
              <br/><br/>
              <b>¿Cómo puede conocer los cambios en este aviso de privacidad?</b>
              El presente aviso de privacidad puede sufrir modificaciones, cambios o actualizaciones derivadas de nuevos requerimientos legales; de nuestras propias necesidades por los productos o servicios que ofrecemos; de nuestras prácticas de privacidad; de cambios en nuestro modelo de negocio, o por otras causas.
              <br/><br/>Nos comprometemos a mantenerlo informado sobre los cambios que pueda sufrir el presente aviso de privacidad, a través de: correo electrónico a info@digital-eureka.com.
              <br/><br/>El procedimiento a través del cual se llevarán a cabo las notificaciones sobre cambios o actualizaciones al presente aviso de privacidad es el siguiente: se actualizará la sección de aviso de privacidad en la página web.
            </div>
          </div>
        </Modal.Body>
      </Modal>
      
    </div>
  );
}

export default App;
